import { runtimeConfig } from "@src/runtime-config";
import {
  Dialog,
  ExperimentalIcon,
  IconButton,
  Tooltip,
  NO_TRANSLATE_CLASS,
  Text,
  neutral,
} from "@flat-ui";
import { useState } from "react";
import { currentUserSelector } from "@store/user/user-selector";
import { useAppSelector } from "@store/store-helper";
import { EmailUtils, RuntimeUtils } from "@stellar/utils";
import { DevFeaturesDialogContent } from "@components/dev-features-dialog/dev-features-dialog-content";
import { Box } from "@mui/material";
import { appStateSelector } from "@store/app/app-selector";
import { shouldShowDevFeaturesButton } from "@components/dev-features-dialog/features-utils";

const isProduction = RuntimeUtils.isProductionEnvironment(runtimeConfig.appEnv);

/**
 * Icon button to open the dialog for development features.
 * @returns An icon button opening the dev features dialog
 */
export function DevFeaturesDialogButton(): JSX.Element | null {
  const [isOpen, setIsMenuOpen] = useState(false);
  const currentUser = useAppSelector(currentUserSelector);
  const isInternalUser = EmailUtils.isInternalUser(currentUser?.email ?? "");
  const { isDevModeEnabled, isAlphaTestingEnabled, isBetaTestingEnabled } =
    useAppSelector(appStateSelector);

  // Checks if the button should be shown depending on the environment and flags
  if (
    !shouldShowDevFeaturesButton({
      isProduction,
      isInternalUser,
      isDevModeEnabled,
      isAlphaTestingEnabled,
      isBetaTestingEnabled,
    })
  ) {
    return null;
  }

  return (
    <Box component="div">
      <Tooltip title="Experimental features" className={NO_TRANSLATE_CLASS}>
        <IconButton onClick={() => setIsMenuOpen(!isOpen)}>
          <ExperimentalIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        title="Experimental Features"
        open={isOpen}
        onClose={() => setIsMenuOpen(false)}
        size="l"
      >
        <Box>
          <Text
            variant="bodyM"
            sx={{
              display: "block",
              color: neutral[600],
              my: 2,
              mt: 0,
            }}
          >
            Debug and test the app with the following tools/features.
          </Text>
          <DevFeaturesDialogContent />
        </Box>
      </Dialog>
    </Box>
  );
}
